module.exports = __webpack_public_path__ + "img/JN-logo.bd0f6c30.webp";